import axios from '../axios';
const END_POINT = '/indications';

const addIndication = (indications) => axios.post(`${END_POINT}`, indications);
const getIndications = (payload) => axios.get(`${END_POINT}?limit=${payload.limit}&page=${payload.page}`);
const getIndication = (indicationsId) => axios.get(`${END_POINT}/${indicationsId}`);
const updateIndications = (indicationsId, payload) => axios.patch(`${END_POINT}/${indicationsId}`, payload);
const searchIndications = (payload) => axios.post(`${END_POINT}/search`, payload);
const deleteIndication = (indicationId) => axios.delete(`${END_POINT}/${indicationId}` )

export {
    addIndication,
    getIndications,
    getIndication,
    updateIndications,
    searchIndications,
    deleteIndication
}